/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Card, Paragraph } from '@zillow/constellation-10';
import { formatStackedNumbers } from '../../utils';
import { isNumber } from '../../utils/isNumber';

export const CustomGraphTooltip = (props: any) => {
  const {
    payload,
    formatter = (value: any) => (isNumber(value) ? formatStackedNumbers(value) : value),
    labelFormatter = (value: any) => value,
    removeEntryOnLabel = [],
    filterPayload,
    displayTotal = false,
    totalKey,
  } = props;

  const displayLabel = payload.length > 0 ? payload[0].payload.name || payload[0].payload.label : null;

  let filteredPayload = payload.filter(
    (entry: any) =>
      !removeEntryOnLabel.some(
        (removeEntry: any) => removeEntry.name === entry.name && displayLabel === removeEntry.value,
      ),
  );

  // Apply custom filter if provided
  if (filterPayload) {
    filteredPayload = filterPayload(filteredPayload, displayLabel, payload);
  }

  // Calculate total if displayTotal is enabled
  const calculatedTotal = displayTotal
    ? totalKey && payload.length > 0 && isNumber(payload[0].payload[totalKey])
      ? payload[0].payload[totalKey]
      : filteredPayload.reduce((sum: number, entry: any) => {
          const value = isNumber(entry.value) ? entry.value : 0;
          return sum + value;
        }, 0)
    : null;

  return (
    <Card
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: '400',
        justifyContent: 'center',
        border: '1px solid',
        borderColor: 'border.muted',
        backgroundColor: 'white',
        padding: '400',
      }}
    >
      <Paragraph>{displayLabel}</Paragraph>
      {displayTotal && calculatedTotal != null && (
        <Box
          css={{
            fontWeight: 'bold',
            paddingBottom: '200',
            borderBottom: '1px solid',
            borderColor: 'border.muted',
          }}
        >
          Total: {formatter(calculatedTotal)}
        </Box>
      )}
      {filteredPayload.map((entry: any, index: number) => {
        const value = isNumber(entry.value) ? (entry.value === 0 ? 'No data' : formatter(entry.value)) : entry.value;

        return (
          <div key={`item-${index}`} style={{ cursor: 'pointer' }}>
            <span
              style={{
                display: 'inline-block',
                width: '10px',
                height: '10px',
                background: entry.splitColors
                  ? `linear-gradient(to right, ${entry.splitColors[0]} 50%, ${entry.splitColors[1]} 50%)`
                  : entry.color,
                marginRight: '5px',
              }}
            />
            {labelFormatter(entry.name)}: {value}
          </div>
        );
      })}
    </Card>
  );
};
